module.exports = __webpack_public_path__ + "img/a62e1d3.png";